import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content-body mt-3 d-flex flex-column justify-content-start align-content-start px-3" }
const _hoisted_2 = { class: "text-start mb-3" }
const _hoisted_3 = { class: "fs-4 fw-bold content-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ManufMethodMgmt = _resolveComponent("ManufMethodMgmt")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_SiteMgmt = _resolveComponent("SiteMgmt")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.t("add_del_items")), 1)
    ]),
    _createVNode(_component_el_tabs, {
      modelValue: _ctx.activeTabName,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTabName) = $event)),
      onTabChange: _ctx.OnTabChanged
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: _ctx.t('manufacture_method'),
          name: "manufMehtod"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ManufMethodMgmt, { ref: "ManufMethodMgmtRef" }, null, 512)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_tab_pane, {
          label: _ctx.t('site'),
          name: "sites"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_SiteMgmt, { ref: "SiteMgmtRef" }, null, 512)
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["modelValue", "onTabChange"])
  ]))
}